import React, { useState } from "react";
import OrdersTableRow from "./OrdersTableRow";
import { Table, TableBody } from "@material-ui/core";
import OrdersTableHead from "./OrdersTableHead";
import DriveFileViewerDialog from "../Shared/DriveFileViewerDialog";

const OrdersTable = ({
  orders,
  handleSort,
}) => {

  const [singleOrderSelection, setSingleOrderSelection] = useState(null);
  const [openOrderDetails, setOpenOrderDetails] = useState(false);

  const handleOpenOrderDetails = (pkg) => {
    setSingleOrderSelection(pkg);
    setOpenOrderDetails(true);
  };

  const handleCloseOrderDetails = () => {
    setSingleOrderSelection(null);
    setOpenOrderDetails(null);
  };

  return (
    <div className="flex-1 overflow-auto">
      <Table width={"100%"} id="default-material-table">
        <OrdersTableHead
          orders={orders}
          handleSort={handleSort}
        />
        <TableBody className="divide-y divide-slate-100">
          {orders?.map((order, index) => {
            return (
              <OrdersTableRow
                key={index}
                order={order}
                onSelectOrder={handleOpenOrderDetails}
              />
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default OrdersTable;
